import { Component, OnInit, inject } from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule } from '@angular/material/tree';

import {TreeDataService} from 'src/app/services/tree-data.service';
import {TreeChoiceService} from '../../../../services/tree-choice.service';

import {TreeItemNode} from 'src/app/model/tree/tree-item-node.model';
import {TreeItemFlatNode} from 'src/app/model/tree/tree-item-flat-node.model';
import {take, takeUntil} from 'rxjs/operators';
import {Destroyed} from '../../../directives/destroyed.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-select-tree',
    templateUrl: './select-tree.component.html',
    styleUrls: ['./select-tree.component.scss'],
    imports: [MatDialogContent, MatTreeModule, NgClass, NgIf, MatButtonModule, MatCheckboxModule, MatIconModule, MatDialogActions]
})
export class SelectTreeComponent extends Destroyed implements OnInit {
    data = inject<{
    canCheckAll: boolean;
    isPlaceTree: boolean;
}>(MAT_DIALOG_DATA);
    private readonly treeDataService = inject(TreeDataService);
    private readonly treeChoiceService = inject(TreeChoiceService);
    dialogRef = inject<MatDialogRef<SelectTreeComponent>>(MatDialogRef);


    selectedNode: TreeItemFlatNode;
    canCheckAll = false;
    listePlace = [];
    listExclude = [];
    /** The selection for checklist */
    checklistSelection = new SelectionModel<TreeItemFlatNode>(false /* unique */);

    treeControl = new FlatTreeControl<TreeItemFlatNode>(
        node => node.level, node => node.expandable);
    treeFlattener: MatTreeFlattener<TreeItemNode, TreeItemFlatNode>;
    dataSource: MatTreeFlatDataSource<TreeItemNode, TreeItemFlatNode>;
    private isPlaceTree = false;

    constructor() {
        super();
        this.treeFlattener = new MatTreeFlattener(
            this.transformer, node => node.level, node => node.expandable, node => node.listOfChilds);

        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
        this.treeDataService.allPlacesMessager.pipe(take(1))
            .subscribe({
                next: (nodes: TreeItemNode[]) => {
                    this.dataSource.data = nodes;
                    this.listePlace = nodes;
                }
            });
    }

    ngOnInit() {

        this.treeDataService.allExcludePlacesMessager
            .pipe(takeUntil(this.destroyed))
            .subscribe(listOfExclude => {
                if (listOfExclude && listOfExclude.length > 0) {
                    this.listExclude = listOfExclude;
                }
            });

        this.canCheckAll = !!this.data.canCheckAll;
        this.isPlaceTree = !!this.data.isPlaceTree;

        if (this.isPlaceTree === true) {
            this.treeControl.dataNodes.forEach(node => {
                if (node.level === 0) {
                    this.treeControl.expand(node);
                }
            });
        }

        if (this.treeChoiceService.hasPlace('placeListPlace')) {
            this.treeControl.dataNodes.forEach(node => {
                if (this.treeChoiceService.getPlace('placeListPlace').some(place => node.name === place)) {
                    this.checklistSelection.select(node);
                }
            });

            if (this.checklistSelection.selected.length === 0 && this.treeControl && this.treeControl.dataNodes) {
                this.treeControl.dataNodes.forEach(node => this.checklistSelection.select(node));
            }
        }

        this.expandSomeNode();
    }

    expandSomeNode() {
        let listTopLevel = this.treeControl.dataNodes.filter(value => !this.treeControl.dataNodes.some(value1 => value.level < value1.level));
        const maxNodes = 5;
        if (listTopLevel && listTopLevel.length < maxNodes) {
            this.treeControl.expandAll();
        } else {
            listTopLevel = this.treeControl.dataNodes.filter(value => value.level === 0);
            if (listTopLevel && listTopLevel.length < maxNodes) {
                listTopLevel.forEach(value => {
                    this.treeControl.expand(value);
                });
            }
        }
    }

    hasChild = (_: number, node: TreeItemFlatNode) => node.expandable;

    onNoClick(): void {
        this.dialogRef.close();
    }

    onValidation() {
        this.dialogRef.close(this.selectedNode);
    }

    checkNode(node: TreeItemFlatNode) {
        if (node === this.selectedNode) {
            return true;
        }

        return false;
    }

    selectNode(node: TreeItemFlatNode) {
        if (this.selectedNode === node) {
            this.selectedNode = null;
        } else {
            this.selectedNode = node;
        }
    }

    canShow = (node: TreeItemFlatNode) => !this.listExclude.some(value => value.id === node.id);

    private readonly transformer = (node: TreeItemNode, level: number): TreeItemFlatNode => {
        return {
            id: node.id,
            expandable: !!node.listOfChilds && node.listOfChilds.length > 0,
            name: node.name,
            level
        };
    };
}


